<template>
      <div class="solveContent">
        <div class="solveContentItem"  v-for="item in solveList" :key="item.ID"  @click="goSolveShow(item)">
          <p class="solveContentImg">
            <!-- <img src="../../img/itemMd.png" alt=""> -->
              <el-image class="CNewItemImgSelf" :src="item.TitlePic">
                <div slot="error" class="image-slot">
                   <img src="~@/assets/img/noNews.png" alt="" >
                 </div>
              </el-image>
          </p>
          <p class="solveContentTitle">{{item.Title}}</p>
          <p class="solveContentDetail">{{item.AddTime|timeFormat}}</p>
        </div>
      </div>
</template>

<script>
// 获取解决方案列表
import { getSolveList } from '@/api/solve'
// 引入时间格式过滤
import { timeFormat } from '@/utils/myFilters'
// 引入根路径
import request from '@/utils/request'
export default {
  props: ['solveId'],
  data () {
    return {
      solveList: [] // 解决方案列表
    }
  },
  filters: {
    timeFormat
  },
  mounted () {
    this.getSolveList({ TypeId: this.solveId })
  },
  methods: {
    // 获取解决方案中心
    async getSolveList (data) {
      const res = await getSolveList(data)
      // console.log(res)
      if (res.Msg === '获取成功') {
        this.solveList = res.Data
        this.solveList.forEach(item => {
          item.TitlePic = request.defaults.baseURL + item.TitlePic
        })
      }
    },
    goSolveShow (item) {
      this.$router.push({ path: `/solveShow/${item.ID}` })
    }
  }

}

</script>

<style lang="scss" scoped>
$md:72/192*2;
  .solveContent{
    width: 690px/$md;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .solveContentItem{
      width: 335px/$md;
      height: 330px/$md;
background: #F8F8F8;
margin-top: 26px/$md;
box-sizing: border-box;
      .solveContentImg{
        width: 335px/$md;
        height: 210px/$md;
        margin: 0;
        .CNewItemImgSelf{
          width: 100%;
          height: 100%;
        }
        img{
          width: 100%;
          height: 100%;
        }
      }
      .solveContentTitle{
        font-size: 22px/$md;
        font-weight: 700;
        margin: 16px/$md 15px/$md  10px/$md  20px/$md;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .solveContentDetail{
        font-size: 20px/$md;
        color: #999999;
        margin: 0px/$md 15px/$md  10px/$md  20px/$md;
      }
    }
  }
</style>
